import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";

export const LeverConnectForm = ({ values, onChange }: ConnectFormProps) => {
  return <div />;
};
